module.exports = __webpack_public_path__ + "static/paris-008-76418a15786f44509136b94ed2ea0e5a.jpg";